import * as types from '../constants/actionTypes';
const initialState = {
	urlToRedirect : null,
	put_revoke_state : "initial"
};

export default function dashboardReducer(state = initialState, action) {
	switch (action.type) {
		case types.GAPI_AUTH:
			return {
                ...state,
                urlToRedirect: action.urlToRedirect.message
            }
		case types.PUT_REVOKE_GAPI_TOKEN:
			return {
                ...state,
                put_revoke_state: action.data
            }
		case types.USER_GOOGLE_SYNC_OPTION:
			return {
                ...state,
			user_google_sync_option: action.data
            }
		case types.USER_OUTLOOK_SYNC_OPTION:
			return {
                ...state,
			user_outlook_sync_option: action.data
            }
		case types.USER_ICLOUD_SYNC_OPTION:
			return {
                ...state,
			user_icloud_sync_option: action.data
            }
		default:
			return state;
	}
}